export const NODE_NAME = 'blockquote';
export const BLOCKQUOTE_REGEX = /^\s*>\s$/;
